import { asciiTextValidation } from 'framework/form';

export const projectCriticalPeriodsValidation = {
  id: {
    type: 'string',
    required: false,
  },
  title: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  startDate: {
    type: 'date',
    required: true,
  },
  endDate: {
    type: 'date',
    required: true,
    minDate: '$startDate',
  },
  description: {
    type: 'string',
    required: false,
    maxSize: 255,
    ...asciiTextValidation,
  },
};
